import { render, staticRenderFns } from "./DragDialog.vue?vue&type=template&id=fe59b57c&scoped=true"
import script from "./DragDialog.vue?vue&type=script&lang=js"
export * from "./DragDialog.vue?vue&type=script&lang=js"
import style0 from "./DragDialog.vue?vue&type=style&index=0&id=fe59b57c&prod&lang=scss&scoped=true"
import style1 from "./DragDialog.vue?vue&type=style&index=1&id=fe59b57c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe59b57c",
  null
  
)

export default component.exports